import * as React from 'react';
import Spinner from './Spinner/Spinner';
import withStyles, { StyledComponentProps } from 'react-jss';
import * as classNames from 'classnames';

export type ImageProps =
    React.HTMLAttributes<HTMLElement> & {
        pictureRef?: PictureRef;
        imageSrc?: string;
        sizes?: string;
        srcSet?: string;
        minWidth?: number;
        maxWidth?: number;
        steps?: number;
        alt?: string;
        // includeRatio?: boolean;
        onLoad?: () => void;
        onError?: () => void;
    } &
    StyledComponentProps<keyof typeof styles>

type State = {
    loading: boolean
};

const styles = {
    container: {
        position: 'relative',
        width: '100%',
        height: '100%',
        zIndex: 0
    },
    loading: {
        position: 'relative',
        width: '100%',
        height: '100%',
        zIndex: 0
    },
    loaded: {
        opacity: 0
    }
};

export class Image extends React.Component<ImageProps, State> {
    readonly state: State = { loading: true };
    public render() {
        const { alt, className, classes } = this.props;
        const { loading } = this.state;

        const maxWidth = this.props.maxWidth || 4000;
        const minWidth = this.props.minWidth || 200;
        let steps = (this.props.steps || 8);
        const stepSize = (maxWidth - minWidth) / steps;
        const sizes = this.props.sizes || '100vw';
        const width = this.props.pictureRef && this.props.pictureRef.Width || 0;
        const imageSrc = this.props.pictureRef && this.props.pictureRef.Src || this.props.imageSrc || '';

        const srcSet: string[] = [];
        steps++;

        while (steps--) {
            const w = stepSize * steps + minWidth;
            if (width && w > width) { continue; }
            const src = `${imageSrc}?width=${w} ${w}w`;
            srcSet.push(src);
        }

        const atts: React.ImgHTMLAttributes<HTMLImageElement> = {
            alt,
            className,
            sizes,
            src: `${imageSrc}`,
            srcSet: srcSet.join(', ') || ''
        };

        atts.onLoad = () => this.setState(() => ({ loading: false }));

        if (this.props.onError) {
            atts.onError = this.props.onError;
        }

        return (
            <div className={classes!.container}>
                {loading && 
                    <div className={classNames(classes!.loading, !loading && classes!.loaded)} >
                        <Spinner />
                    </div>
                }
                <img
                    {...atts}
                />
            </div>
        );

    }
}

export default withStyles(styles)(Image);


// WEBPACK FOOTER //
// ./src/Components/Image.tsx